/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React, { forwardRef } from "react"
import { makeStyles } from "@material-ui/core"
import "../../assets/print/work-order-page.css"
import clsx from "clsx"
import HeaderPrint from "components/common/print/HeaderPrint"
import { formatDate } from "utils/form-data"

const useStyles = makeStyles({
  logo: {
    width: "12mm",
  },
  normalFont: {
    fontSize: "9pt",
  },
  pageHeaderContent: {
    width: "180mm",
    display: "flex",
    alignItems: "center",
    fontWeight: "bolder",
    fontStyle: "italic",
  },
  tableTitle: {
    fontWeight: "bold",
    marginBottom: "2mm",
  },
  page: {
    fontSize: "10pt",
    lineHeight: 1.1,
    "& table": {
      textAlign: "left",
    },
    "& th, & td, & tr": {
      // Remove row space by default
      marginBottom: 0,
      paddingBottom: 0,
    },
    "& table.table-headleft th": {
      paddingRight: "5mm",
    },
    "& table.table-headleft td": {
      textAlign: "right",
    },
    "& #general td": {
      textAlign: "left",
    },
    "& .table-long": {
      "& thead > * > *": {
        borderTop: "0.3mm solid black",
        borderBottom: "0.3mm solid black",
        padding: "1.1mm 2.6mm",
      },
      "& tbody > * > *": {
        padding: "1.05mm 2.6mm",
      },
      "& tbody > *:last-child > *": {
        borderBottom: "0.3mm solid black",
      },
    },
    "& #left-list": {
      "& tbody > * > *": {
        padding: "1.05mm 2.6mm",
        fontSize: "9pt",
      },
      "& thead > * > *": {
        fontSize: "9pt",
      },
    },
    "& #item-table": {
      "& tbody > * > *": {
        padding: "1.05mm 2.6mm",
        fontSize: "9pt",
      },
      "& thead > * > *": {
        fontSize: "9pt",
      },
    },
    "& .table-handling": {
      paddingRight: "2.6mm",
      pageBreakInside: "avoid",
      marginBottom: "3mm",
    },
    "& .table-handling tbody": {
      pageBreakInside: "avoid",
    },
    "& .title": {
      marginTop: 0,
      fontSize: "inherit",
    },
  },
  totalCostsTable: {
    "& * > * > *": {
      padding: "1.1mm 2.6mm",
      textAlign: "right",
    },
    "& * > * > :nth-child(1)": {
      textAlign: "left",
    },
    "& tbody > *:last-child > *": {
      paddingBottom: "1.7mm",
    },
    "& tfoot > *:first-child > *": {
      borderTop: "0.3mm solid black",
      paddingTop: "1.7mm",
    },
  },
  marginTable: {
    "& * > * > *": {
      padding: "1.1mm 2.6mm",
      textAlign: "right",
    },
  },
  approvedBox: {
    border: "0.3mm solid black",
    height: "15.5mm",
  },
  noBorder: {
    border: "none",
    width: "100%",
    padding: 0,
    // margin: "-10mm",
  },
})

const WOPrintForm = forwardRef(
  (
    {
      data,
      estimateList,
      approver = [],
      className,
      companyInformation,
      customerData,
      showAcknowledgedBy,
      showMadeBy,
      showApprovedBy,
    },
    ref
  ) => {
    const classes = useStyles()
    // const marketingHead = process.env.REACT_APP_MARKETING_HEAD
    // const generalManager = process.env.REACT_APP_GENERAL_MANAGER
    // const marketingDeptName =
    //   process.env.REACT_APP_MARKETING_DEPT_TITLE_NAME || "Marketing"
    // const generalManagerTitle =
    //   process.env.REACT_APP_GENERAL_TITLE_NAME || "General Manager"

    const uniqueArr = Array.from(
      new Set(
        estimateList.map(
          (item) => item.salesEstimate?.estQuot?.rfq?.projectName ?? "-"
        )
      )
    )
    const estNumbers = Array.from(
      new Set(
        estimateList
          .map((item) => item.salesEstimate?.estQuot?.estimationNumber || "")
          .filter((item) => item)
      )
    )

    const leftTable = (
      <table id="left-list">
        <tbody className={classes.normalFont}>
          <tr>
            <td>Customer:</td>
            <td>{customerData?.name}</td>
          </tr>
          <tr>
            <td>Project Name:</td>
            <td>{data?.projectName ?? uniqueArr.join(", ")}</td>
          </tr>
          <tr>
            <td>PO No:</td>
            <td>
              {estimateList
                .map((item) => item?.salesEstimate?.slsPurchaseOrder?.poNumber)
                .filter((item) => item)
                .join(", ")}
            </td>
          </tr>
          <tr>
            <td>Status</td>
            <td>{data?.status}</td>
          </tr>
        </tbody>
      </table>
    )
    return (
      <div
        ref={ref}
        className={clsx(classes.page, className, "print-container")}
        id="print-container"
      >
        <section className={clsx("chapter", "wo-print")}>
          <HeaderPrint
            companyInformation={companyInformation}
            typeDocument="Internal"
          />

          <div id="recipent-header">
            <div id="recipent-list">
              <span className={classes.normalFont}>Kepada:</span>
              <p className={classes.normalFont}>
                {approver.map((item, id) => (
                  <React.Fragment key={id}>
                    Departemen {item.deptName}
                    <br />
                  </React.Fragment>
                ))}
              </p>
            </div>

            <div id="recipent-signatures">
              <table className="with-border" cellSpacing={0}>
                <thead>
                  <tr>
                    {approver.map((item, id) => (
                      <td key={id} className={classes.normalFont}>
                        {item.deptName} Dept.
                      </td>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {approver.map((item, id) => (
                      <td key={id} className={classes.normalFont}>
                        {item.pic}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div id="wo-notice-container">
            <div id="wo-notice">
              <h1
                style={{
                  // textAlign: "left",
                  // marginTop: "-2em",
                  fontSize: "18pt",
                  textDecoration: "underline",
                  textTransform: "uppercase",
                }}
              >
                Work Order
              </h1>
              Diberitahukan kepada semua departemen terkait, bahwa dengan
              terbitnya work order ini, menyatakan bahwa project sebagai
              berikut:
              {leftTable}
            </div>
            <div id="wo-numbers" style={{ position: "relative" }}>
              <table style={{ position: "absolute", right: 0 }}>
                <tbody className={classes.normalFont}>
                  <tr>
                    <td>WO No:</td>
                    <td>{data.woNumber}</td>
                  </tr>
                  <tr>
                    <td>WO Date:</td>
                    <td>{formatDate(data.woDate)}</td>
                  </tr>
                  <tr>
                    <td>Est No:</td>
                    <td>{estNumbers.join()}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <table id="item-table" className="with-border" cellSpacing={0}>
            <thead>
              <tr>
                <th rowSpan="2" className={classes.normalFont}>
                  No
                </th>
                <th
                  rowSpan="2"
                  className={classes.normalFont}
                  // style={{ width: "35%" }}
                >
                  Product Name
                </th>
                <th rowSpan="2" className={classes.normalFont}>
                  Product Code
                </th>
                <th colSpan="2" className={classes.normalFont}>
                  Due Date
                </th>
              </tr>
              <tr>
                <th className={classes.normalFont}>Delivery</th>
                <th className={classes.normalFont}>Schedule</th>
              </tr>
            </thead>
            <tbody>
              {estimateList.map((item, index) => {
                const { schedules } = item

                return (
                  <tr key={index}>
                    <td className={classes.normalFont}>{index + 1}</td>
                    <td
                      className={classes.normalFont}
                      style={{ textAlign: "left" }}
                    >
                      <strong className={classes.normalFont}>
                        {item?.description ??
                          item?.salesEstimate?.description ??
                          "-"}
                      </strong>

                      <p
                        style={{ whiteSpace: "pre-line", marginTop: "0" }}
                        className={classes.normalFont}
                      >
                        {item?.remark}
                      </p>
                    </td>
                    <td className={classes.normalFont}>{item?.mouldCode}</td>
                    <td className={classes.normalFont}>
                      {formatDate(item?.dueDateDelivery, true)}
                    </td>
                    <td className={classes.normalFont}>
                      {!schedules.length ? "" : null}
                      {schedules.length > 0 ? (
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          {schedules.map((schedule, i) => (
                            <span key={`${schedule.name}${i}`}>
                              {schedule.name} :{" "}
                              {formatDate(schedule.date, true)}
                            </span>
                          ))}
                        </div>
                      ) : null}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          <p>
            sudah dapat dimulai proses produksi sesuai dengan kondisi dan
            persyaratan yang telah disepakati kedua belah pihak.
          </p>

          <p style={{ marginTop: "-1em" }}>
            Demikianlah work order ini dibuat sebagai konfirmasi internal untuk
            segera dilakukan persiapan-persiapan produksi dari semua pihak
            terkait agar tercapai target on time delivery dan kualitas sesuai
            permintaan dan syarat-syarat dari pelanggan.
          </p>

          <div id="bottom-approval">
            <div id="approvals">
              <table>
                <tbody className={classes.normalFont}>
                  <tr>
                    <td colSpan={3}>
                      <p style={{ margin: 0 }}>Hormat kami,</p>
                    </td>
                  </tr>
                  <tr>
                    {showMadeBy ? (
                      <td>
                        <p style={{ margin: 0 }}>Dibuat oleh,</p>
                        <p className="signature-space" />
                        <br />
                        <br />
                        <u>{data?.madeBy}</u>
                      </td>
                    ) : null}
                    {showAcknowledgedBy ? (
                      <td>
                        <p style={{ margin: 0 }}>Mengetahui,</p>
                        <p className="signature-space" />
                        <br />
                        <br />
                        <u>{data?.acknowledgeBy}</u>
                      </td>
                    ) : null}
                    {showApprovedBy ? (
                      <td>
                        <p style={{ margin: 0 }}>Disetujui oleh,</p>
                        <p className="signature-space" />
                        <br />
                        <br />
                        <u>{data?.approvedBy}</u>
                      </td>
                    ) : null}
                  </tr>
                </tbody>
              </table>
            </div>
            <table
              id="delivery-checked"
              cellSpacing={0}
              className="with-border"
            >
              <tbody className={classes.normalFont}>
                <tr>
                  <td
                    colSpan="2"
                    style={{ textAlign: "center", textTransform: "uppercase" }}
                  >
                    Delivery Checked
                  </td>
                </tr>
                <tr>
                  <td style={{ borderBottom: "none", width: "6em" }}>Date</td>
                  <td />
                </tr>
                <tr>
                  <td style={{ borderTop: "none" }}>Issued by</td>
                  <td />
                </tr>
                <tr>
                  <td
                    colSpan="2"
                    style={{ height: "2rem", verticalAlign: "baseline" }}
                  >
                    <span>Remarks</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    )
  }
)

export default WOPrintForm
